import React, { useEffect } from 'react';

import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';

import {
  trackSunbitModalPageView,
  trackSunbitSiteExitCTA,
} from '~/pdp/actions';
import CloseButton from '~/shared/components/CloseButton';
import FableticsModal from '~/shared/components/FableticsModal/FableticsModal';
import { desktop } from '~/techstyle-shared/react-components';

import SunbitModalContent from './SunbitModalContent';

interface SunbitModalProps {
  ctaUrl?: string;
  eligibleVariant?: string;
  expiryDate?: string;
  firstName?: string;
  isOpen?: boolean;
  offerAmount?: string;
  onClose?: () => void;
}

const SunbitCloseButton = styled(CloseButton)`
  position: absolute;
  inset: 15.45px 16px auto auto;
  color: ${({ theme }) => theme.colors.sunbitCloseButtonColor};
  z-index: 10;
  width: 14px;
  height: 13px;
`;

const dialogStyle = css`
  background: transparent;
  border-radius: 16px;
  padding: 0;
  max-width: 350px;
  height: 589px;
  width: 100%;

  ${desktop`
    max-width: 480px;
    height: 680px;
  `}
`;

const contentWrapperStyles = css`
  background: none;
  position: relative;
  width: 100%;
  height: 100%;
`;

export default function SunbitModal({
  ctaUrl,
  eligibleVariant,
  expiryDate,
  firstName,
  isOpen = false,
  offerAmount,
  onClose,
}: SunbitModalProps) {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    if (isOpen) {
      dispatch(
        trackSunbitModalPageView(
          {
            pageName: '/sunbit-credit-card-modal',
          },
          {}
        )
      );
    }
  }, [isOpen, dispatch]);

  const handleModalExit = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleCTAClick = () => {
    dispatch(
      trackSunbitSiteExitCTA(
        {
          invitationLink: ctaUrl || null,
          expiryDate: expiryDate || null,
          creditLine: offerAmount ? Number(offerAmount) : null,
          invitationType: eligibleVariant || null,
          loyaltyPoints: null,
        },
        {}
      )
    );

    if (ctaUrl) {
      router.push(ctaUrl);
    }
    handleModalExit();
  };

  return (
    <FableticsModal
      title="sunbit_modal"
      dialogStyle={dialogStyle}
      contentWrapperStyles={contentWrapperStyles}
      showCloseButton
      closeButton={<SunbitCloseButton data-autotag="SunbitCloseButton" />}
      isOpen={isOpen}
      onExit={handleModalExit}
      onEnter={() => {}}
      data-autotag="SunbitModal"
      trigger={undefined}
      openDelay={undefined}
    >
      <SunbitModalContent
        firstName={firstName}
        offerAmount={offerAmount}
        onCTAClick={handleCTAClick}
        eligibleVariant={eligibleVariant}
      />
    </FableticsModal>
  );
}
